import { render } from "./BenchmarkCases.vue?vue&type=template&id=589becf2&scoped=true"
import script from "./BenchmarkCases.vue?vue&type=script&lang=js"
export * from "./BenchmarkCases.vue?vue&type=script&lang=js"

import "./BenchmarkCases.vue?vue&type=style&index=0&id=589becf2&lang=scss&scoped=true"

import exportComponent from "E:\\developYZ\\yzWebsite\\newWebsite\\my-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589becf2"]])

export default __exports__